export default __webpack_public_path__ + "static/FS2S-InHub-32-74738b26f4f5fe28df5d59eb018f07ac.jpg";